<template>
  <div class="navigation">
    <div class="search">
      <a-input-search v-model="filterForm.query" class="navigation-search_input" placeholder="搜索" size="large" @change="onSearch" @search="onSearch" @keyup.enter.native="onSearch">
        <a-button slot="enterButton" type="primary" icon="search" class="navigation-search_button" />
      </a-input-search>
      <div class="navigation-history">
        <span class="navigation-history_label"><a-icon type="fire" theme="twoTone" two-tone-color="red" /> 我常用的: </span>
        <span v-for="navigation in usuallyNavigations" :key="navigation.id" class="navigation-history_item" @click="onNavigation(navigation)"><a-avatar :src="navigation.logo" :size="16" /> {{ navigation.title }}</span>
      </div>
      <div class="navigation-history">
        <span class="navigation-history_label"><a-icon type="clock-circle" theme="twoTone" /> 最近访问: </span>
        <span v-for="navigation in latestNavigations" :key="navigation.id" class="navigation-history_item" @click="onNavigation(navigation)"><a-avatar :src="navigation.logo" :size="16" /> {{ navigation.title }}</span>
      </div>
    </div>
    <div>
      <div v-for="categoryNavigation in categoryNavigations" :key="categoryNavigation.id" class="category-item">
        <span class="category-item_name">{{ categoryNavigation.name }}</span>
        <a-row :gutter="12">
          <a-col v-for="navigation in categoryNavigation.navigations" :key="navigation.id" :span="6">
            <a-card hoverable class="navigation-item" @click="onNavigation(navigation)">
              <div class="navigation-item-logo">
                <a-avatar :src="navigation.logo" :size="48" />
              </div>
              <div class="navigation-item-content">
                <span class="navigation-item-content_title">{{ navigation.title }}</span>
                <a-tooltip placement="top">
                  <template slot="title">
                    <span>{{ navigation.description }}</span>
                  </template>
                  <span class="navigation-item-content_description">{{ navigation.description }}</span>
                </a-tooltip>
              </div>
              <div class="navigation-more">{{ navigation.click_volume }} <a-icon type="eye" /></div>
            </a-card>
          </a-col>
        </a-row>
      </div>
    </div>
  </div>
</template>

<script>
import { navigationItems, navigationClick, navigationUserUsually, navigationUserLatest } from '@/api/system/navigation';
import { getCookies } from '@/utils/utils';

export default {
  data() {
    return {
      loading: false,
      filterForm: {
        query: null,
        page_size: 10,
        page_number: 1
      },
      token: getCookies(),
      categoryNavigations: [],
      usuallyNavigations: [],
      latestNavigations: []
    };
  },
  created() {
    this.getNavigationItems();
    this.getUsuallyNavigations();
    this.getLatestNavigations();
  },
  methods: {
    getNavigationItems() {
      navigationItems(this.filterForm)
        .then(res => {
          this.categoryNavigations = res.data.items;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    getUsuallyNavigations() {
      navigationUserUsually(this.filterForm).then(res => {
        this.usuallyNavigations = res.data.items;
      });
    },

    getLatestNavigations() {
      navigationUserLatest(this.filterForm).then(res => {
        this.latestNavigations = res.data.items;
      });
    },

    onSearch() {
      this.getNavigationItems();
    },

    onNavigation(navigation) {
      if (this.token !== null && this.token !== '') {
        navigationClick({ id: navigation.id }).then(() => {
          this.getNavigationItems();
          this.getUsuallyNavigations();
          this.getLatestNavigations();
        });
      }
      if (navigation.url.substring(0, 4) !== 'http') {
        this.$router.push(navigation.url);
      } else {
        window.open(navigation.url);
      }
    }
  }
};
</script>

<style lang="less" scoped>
.navigation {
  margin: 0px auto;
  width: 1040px;
}
/deep/ .ant-btn {
  border-radius: 24px;
  height: 48px;
}

/deep/.ant-input {
  border-radius: 24px;
  height: 48px;
  padding: 23px;
}
.search {
  margin-bottom: 16px;
  height: 100px;
  .navigation-search_button {
    width: 104px;
  }
}

.ant-btn {
  border-radius: 25px;
}

.category-item {
  width: 100%;
  clear: left;
  .category-item_name {
    line-height: 24px;
    font-weight: bold;
  }
}

/deep/.navigation-item {
  cursor: pointer;
  position: relative;
  margin: 6px 0;
  .ant-card-body {
    padding: 12px;
  }
  .navigation-item-logo {
    float: left;
    margin-right: 8px;
  }
  .navigation-item-content {
    .navigation-item-content_title {
      font-size: 16px;
      line-height: 22px;
      padding-top: 4px;
      font-weight: bold;
      display: block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .navigation-item-content_description {
      font-size: 12px;
      line-height: 22px;
      color: #999;
      display: block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
.navigation-item:hover {
  .navigation-more {
    opacity: 1;
    transform: translateY(0%);
  }
}
.navigation-more {
  position: absolute;
  cursor: pointer;
  right: 8px;
  top: 4px;
  font-size: 12px;
  opacity: 0;
  color: #909399;
}

.navigation-history {
  line-height: 24px;
  margin: 8px 0;
  .navigation-history_label {
    margin: 4px 0;
    line-height: 16px;
    display: block;
    float: left;
    clear: left;
  }

  .navigation-history_item {
    display: block;
    float: left;
    cursor: pointer;
    margin: 4px 8px;
    line-height: 16px;
    max-width: 100px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
